import { fetchFlask } from '../../utils/fetchFlask';
import { parseNumberPtBr } from '../../utils/numberUtils';

export const CRM_LEADS_LIST_API = 'crm/leads';
export const CRM_LEADS_REPORT_API = 'crm/leadsReport';
export const CRM_LEAD_TEXT_FILTER_FIELDS = ['lead_id', 'telefone', 'nome', 'email', 'cpf', 'cupom', 'source', 'campaign', 'content', 'term'];
export const CRM_LEAD_INTEGER_FILTER_FIELDS = ['cliente_id'];
export const CRM_LEAD_DEBOUNCED_FILTER_FIELDS = [...CRM_LEAD_TEXT_FILTER_FIELDS, ...CRM_LEAD_INTEGER_FILTER_FIELDS];
export const CRM_LEAD_SELECT_FILTER_FIELDS = ['vendedor_id', 'status_id', 'fase_id', 'origem_id'];
export const CRM_LEAD_TICKET_ORDER_FIELD = 'ordem_id';
export const CRM_LEAD_WON_PHASE_ID = 5;
// Com a fase travada em Conquistado, Status e Fase nao informam nada: saem da tabela.
export const CRM_LEAD_PHASE_LOCKED_HIDDEN_FIELDS = ['status', 'fase'];
export const CRM_LEAD_DATE_FILTER_RANGES = {
    cadastro: { start: 'cadastro_inicio', end: 'cadastro_fim' },
    phase_four_date: { start: 'contrato_inicio', end: 'contrato_fim' },
    phase_five_date: { start: 'conquistado_inicio', end: 'conquistado_fim' }
};
export const CRM_LEADS_INITIAL_DATE_FILTERS = Object.values(CRM_LEAD_DATE_FILTER_RANGES)
    .reduce((filters, range) => ({
        ...filters,
        [range.start]: null,
        [range.end]: null
    }), {});
export const CRM_LEADS_INITIAL_FILTERS = {
    vendedor_id: '',
    status_id: [],
    fase_id: '',
    origem_id: '',
    lead_id: '',
    cliente_id: null,
    telefone: '',
    nome: '',
    email: '',
    cpf: '',
    cupom: '',
    source: '',
    campaign: '',
    content: '',
    term: '',
    ordem_id: 0
};

export const toIdArray = (value) => {
    if (Array.isArray(value)) return value;
    return value === '' || value === null || value === undefined ? [] : [value];
};

export const buildCrmLeadsPayload = ({ dateFilters, filters, page, pageSize }) => JSON.stringify({
    cadastro_inicio: dateFilters.cadastro_inicio,
    cadastro_fim: dateFilters.cadastro_fim,
    contrato_inicio: dateFilters.contrato_inicio,
    contrato_fim: dateFilters.contrato_fim,
    conquistado_inicio: dateFilters.conquistado_inicio,
    conquistado_fim: dateFilters.conquistado_fim,
    vendedor_id: toIdArray(filters.vendedor_id),
    status_id: toIdArray(filters.status_id),
    fase_id: toIdArray(filters.fase_id),
    origem_id: toIdArray(filters.origem_id),
    lead_id: filters.lead_id,
    cliente_id: filters.cliente_id,
    telefone: filters.telefone,
    nome: filters.nome,
    email: filters.email,
    cpf: filters.cpf,
    cupom: filters.cupom,
    source: filters.source,
    campaign: filters.campaign,
    content: filters.content,
    term: filters.term,
    ordem_id: filters.ordem_id,
    page,
    page_size: pageSize
});

export const fetchCrmLeadsPage = async ({ dateFilters, filters, page, pageSize }) => {
    const response = await fetchFlask(CRM_LEADS_LIST_API, buildCrmLeadsPayload({
        dateFilters,
        filters,
        page,
        pageSize
    }));

    return {
        ...response.data,
        totalTicket: response.data.total_ticket !== undefined || response.data.totalTicket !== undefined
            ? parseNumberPtBr(response.data.total_ticket ?? response.data.totalTicket)
            : null
    };
};

export const fetchCrmLeadsReport = ({ dateFilters, filters, page, pageSize }) => fetchFlask(
    CRM_LEADS_REPORT_API,
    buildCrmLeadsPayload({
        dateFilters,
        filters,
        page,
        pageSize
    })
);
